let ignoreApplicationSave = false,
    lastFormSaveAction = 0,
    showKeepAliveHashError = true;

let saveApplicationForm = function() {
    if(ignoreApplicationSave) {
        return;
    }

    let form = jQuery('.application-form');
    jQuery.post( form.attr('action'), form.serialize(), function(response) {
        // Timestamp will have updated, so no need to keep alive.
        lastFormSaveAction = Math.round(new Date() / 1000);
        if(response.message === 'hash-mismatch') {
            showKeepAliveHashError = false;
            if(confirm('Oops! Seems you have two forms open at once, we need to refresh to continue')) {
                window.location.reload();
            }
        }
    });
};

let keepApplicationAlive = function() {
    if(ignoreApplicationSave) {
        return;
    }

    // We wont want to keep showing this if we'e already shown it once.
    if(showKeepAliveHashError === false) {
        return;
    }

    // We only need to fire this off every minute.
    if(lastFormSaveAction > (Math.round(new Date() / 1000) - 60)) {
        return;
    }

    jQuery.post('apply-online/keep-alive', {'Hash' : jQuery('.application-form input[name=Hash]').val()}, function(response) {
        lastFormSaveAction = Math.round(new Date() / 1000);
        if(response.message === 'hash-mismatch') {
            showKeepAliveHashError = false;
            if(confirm('Oops! Seems you have two forms open at once, we need to refresh to continue')) {
                window.location.reload();
            }
        }
    });
};

jQuery( document ).ready(function() {
    let form = jQuery('.application-form');

    if(form.length) {
        form.on('submit', function() {
            ignoreApplicationSave = true;
        });

        // Bind us if we change the inputs for auto saving
        form.find('input').on('keyup change keypress', debounce(saveApplicationForm, 1500)); // this could be radio buttons as well.
        form.find('textarea').on('keyup change keypress', debounce(saveApplicationForm, 1500));
        form.find('select').on('change click', debounce(saveApplicationForm, 1500));

        // Set the the keep alive

        // If the user comes back to this tab,
        document.addEventListener("visibilitychange", keepApplicationAlive);
        // Every 30 check if it's been 60 seconds and keep it alive
        setInterval( keepApplicationAlive, 30000 );


        // Scroll to the next error on the form.
         // However - we need to delay by a little so all other element hide / show
        setTimeout(function() {
            jQuery.each(form.find('.application-form-error'), function(i, element) {
                if(jQuery(element).text().trim() !== '') {
                    jQuery(element).closest('.form-group')[0].scrollIntoView();
                    return false; // false breaks, true continues.
                }
            });
        }, 100);

    }

});